import React, {useEffect} from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {CookiesProvider} from 'react-cookie'
import {Provider, useDispatch} from 'react-redux'
import { setUser } from './store/actions';
import { auth } from './cloud/gcp/config';
import store from './store';

const AuthInit: React.FC = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    let unsubscribe: () => void;
    (async () => {
      await auth.authStateReady()
     unsubscribe = auth.onAuthStateChanged(async (user) => {
          if (user) {
            console.log("AuthStateChanged", user.uid);
            dispatch(setUser(user));
          }
          if (user === null) {
            console.log("AuthStateChanged: user is null(logout)");
            dispatch(setUser(null));
          }
      })
    })();

    return () => {
      unsubscribe();
    }
  }, [dispatch]);
  return <App />
}
  


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <CookiesProvider>
        <AuthInit />
      </CookiesProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
